'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true,
});
exports.default = void 0;

var _jsxRuntime = require('react/jsx-runtime');

var _core = require('@material-ui/core');

var _styles = require('@material-ui/core/styles');

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly)
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    keys.push.apply(keys, symbols);
  }
  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(
          target,
          key,
          Object.getOwnPropertyDescriptor(source, key)
        );
      });
    }
  }
  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true,
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

var useStyles = (0, _styles.makeStyles)({
  root: function root(props) {
    var fontWeight = props.fontWeight
      ? {
          fontWeight: props.fontWeight,
        }
      : {};
    var fontSize = props.fontSize
      ? {
          fontSize: props.fontSize,
        }
      : {};
    var textAlign = props.textAlign
      ? {
          textAlign: props.textAlign,
        }
      : {};
    return _objectSpread({}, fontWeight, {}, fontSize, {}, textAlign);
  },
});

var sanitizeProps = function sanitizeProps(_ref) {
  var fontWeight = _ref.fontWeight,
    fontSize = _ref.fontSize,
    textAlign = _ref.textAlign,
    props = _objectWithoutProperties(_ref, [
      'fontWeight',
      'fontSize',
      'textAlign',
    ]);

  return props;
};
/**
 * Replacement for `Typography`, which accepts `fontWeight`, `fontSize`, `textAlign` as props
 */

var CustomTypography = function CustomTypography(props) {
  var classes = useStyles(props);
  var sanitizedProps = sanitizeProps(props);
  return /*#__PURE__*/ (0, _jsxRuntime.jsx)(
    _core.Typography,
    _objectSpread({}, sanitizedProps, {
      className: classes.root,
    })
  );
};

var _default = CustomTypography;
exports.default = _default;

//# sourceMappingURL=index.js.map
